<template>
    <div class="org-container pointer box-shadow mb-4 p-3">
        <div class="campaign-item-pic"
             v-bind:style="{ backgroundImage: 'url(' + getImageUrl() + ')', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', backgroundSize:'contain' }">
            <transition name="fade">
                <div v-if="!backgroundImageLoaded" class="header-img-overlay">
                </div>
            </transition>
        </div>
        <div class="m-2">
            <span class="category-info-text category-organization-text">
                {{ organization.name }}
            </span>
        </div>
    </div>
</template>

<script>
import FairApi from "@/modules/api";

export default {
    name: "category-organizations-feed-item",
    props: {
        organization: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            photo: '',
            backgroundImageLoaded: false
        }
    },
    created() {
       this.fetchPhoto()
    },
    methods: {
        getImageUrl() {
            return this.photo
        },
        fetchPhoto() {
            if (this.organization.photo) {
                FairApi.get(FairApi.photo(this.organization.photo.id), response => {
                    this.photo = response
                    this.backgroundImageLoaded = true
                }, function () {
                })
            }
        }
    }
}
</script>

<style scoped>
.org-container {
    border: 2px solid #d2d2d2;
    box-shadow: 4px 4px 10px #d2d2d2;
    border-radius: 10px;
}
.org-container:hover {
    border-color: #34D2FF;
    border-width: 2px;
}
</style>
